import { alpha, Paper, PaperProps, styled } from '@mui/material';
import { constructStyledOptions } from '@/utils/style';

interface ContainerProps {
  hasMarginTop?: boolean;
}

type ContainerPropsExtended = ContainerProps & PaperProps;

const containerPropsToNotForward: Array<keyof ContainerProps> = ['hasMarginTop'];
const styledOptions = constructStyledOptions({
  propsToNotForward: containerPropsToNotForward,
});

export const Container = styled(
  Paper,
  styledOptions
)<ContainerPropsExtended>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: alpha(theme.palette.primary.light, 0.1),
  padding: theme.spacing(2, 2, 0, 2),
  marginTop: theme.spacing(1),
}));
